var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buy-button-base"},[_c('base-button',{attrs:{"label":_vm.buttonFace,"is-disabled":_vm.isDisabled},on:{"clicked":_vm.onBtnClick}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60fea8aa","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/partials/BuyButton.vue
// module id = null
// module chunks = 